// Namespace "public" — pages publiques tenant (réservation, boutique, journal, cours).
// Créé vide lors du split ; les lots H/I apportent leurs fragments.
export default { fr: {}, en: {}, es: {} };
